import React, { useState } from 'react';
import { IonText } from '@ionic/react';
import Dropzone, { IFileWithMeta, StatusValue } from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { ArtistId } from '../models/Artist';
import { MediaReference } from '../models/Song';
import { TransmissionService } from '../services/TransmissionService';

interface StateProps {
    ownerId?: ArtistId
}
interface OwnProps {
    message?: string
    collection: string
    onComplete: (media: MediaReference) => void
}
interface DispatchProps {
}
interface UploaderProps extends OwnProps, StateProps, DispatchProps { }

const Uploader: React.FC<UploaderProps> = ({ collection, onComplete, message }) => {
    const [uploadError, setUploadError] = useState<string>();
    // There's no getUploadParams, so Dropzone marks a file 'done' as soon as
    // it's picked; the upload itself goes through the Firebase Storage SDK
    // (TransmissionService.UploadImage), keyed by the signed-in user's uid.
    const handleChangeStatus = (file: IFileWithMeta, status: StatusValue) => {
        if (status !== 'done') return;
        setUploadError(undefined);
        TransmissionService.UploadImage(collection, file.file).then((src) => {
            onComplete({ src, type: file.file.type } as MediaReference);
        }).catch((err) => {
            console.error("Upload failed", err);
            setUploadError("Upload failed. Please try again.");
            // Drop the file so the picker comes back for a retry.
            file.remove();
        });
    }

    return (
        <Dropzone
            maxFiles={1}
            onChangeStatus={handleChangeStatus}
            canCancel={false}
            multiple={false}
            maxSizeBytes={104857600}
            inputContent={(message && message) || "select an mp3/m4a"}
            accept={collection === "songs" ? "audio/m4a" : "image/*"}
            inputWithFilesContent="Add file"
            styles={{
                dropzone: { overflow: 'auto' },
            }}
            InputComponent={({ accept, onFiles, files, getFilesFromEvent }) => (
                <label style={{ cursor: 'pointer', width: '100%', textAlign: 'center', padding: '20px' }}>
                    {(message && message) || "select an mp3/m4a"}
                    {uploadError && (
                        <IonText color="danger" role="alert" style={{ display: 'block' }}>
                            {uploadError}
                        </IonText>
                    )}
                    <input
                        style={{ display: 'none' }}
                        type="file"
                        accept={accept}
                        onChange={async (e) => {
                            const target = e.target;
                            const chosenFiles = await getFilesFromEvent(e);
                            onFiles(chosenFiles as File[]);
                            target.value = '';
                        }}
                        aria-label={message || "Upload file"}
                    />
                </label>
            )}
        />
    )
}


export default Uploader;
